/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorDocumentDto } from '../../models/vendor-document-dto';

export interface VendorDocumentControllerFindById$Params {
  id: string;
}

export function vendorDocumentControllerFindById(http: HttpClient, rootUrl: string, params: VendorDocumentControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorDocumentDto>> {
  const rb = new RequestBuilder(rootUrl, vendorDocumentControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorDocumentDto>;
    })
  );
}

vendorDocumentControllerFindById.PATH = '/api/vendorDocument/{id}';
